import React, { useEffect, useState } from 'react';

interface StagePreWelcomeProps {
  onContinue: () => void;
}

// Duration of the animated webp in milliseconds
const ANIMATION_DURATION = 5000; // 5 seconds - adjust based on actual animation length
const FADE_IN_DURATION = 500; // Fade in duration in milliseconds

export const StagePreWelcome: React.FC<StagePreWelcomeProps> = ({ onContinue }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Trigger fade in on mount
    const fadeInTimer = setTimeout(() => {
      setIsVisible(true);
    }, 50); // Small delay to ensure transition triggers

    // Start fade out after animation plays
    const fadeOutTimer = setTimeout(
      () => {
        setIsFading(true);
      },
      ANIMATION_DURATION + FADE_IN_DURATION - 500
    );

    // Complete transition after fade out
    const completeTimer = setTimeout(() => {
      onContinue();
    }, ANIMATION_DURATION + FADE_IN_DURATION);

    return () => {
      clearTimeout(fadeInTimer);
      clearTimeout(fadeOutTimer);
      clearTimeout(completeTimer);
    };
  }, [onContinue]);

  return (
    <div
      className={`fixed inset-0 z-50 bg-black flex items-center justify-center transition-opacity duration-500 ${
        isFading ? 'opacity-0' : isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <img
        src="/onboarding/ONBOARDINGSET-UP.webp"
        alt="Onboarding Setup"
        className="w-full h-full object-contain max-w-full max-h-full"
      />
    </div>
  );
};
